import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Container, Typography, Box } from '@mui/material';
import Logo from '../components/logo';
import { ForgotPassword } from '../sections/auth/login';
import { removeToken } from '../services/LocalStorageService';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '80vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));


export default function UserForgotPassword() {
  removeToken();

  return (
    <>
      <Helmet>
        <title>DV Agent </title>
      </Helmet>
      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />
        <Container maxWidth="sm">
          <StyledContent>
            <ForgotPassword/>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:50 }}>
              <Box to="/" component={RouterLink}>
                <img width={20} src="../../assets/back-button.gif" alt="back" />
              </Box>
              <Typography
                to="/" component={RouterLink}
                gutterBottom
                variant=""
                sx={{
                  marginTop:1,
                  fontSize: 16,
                  textDecoration: 'none',
                  color: "#A8A196"
                }}
              >
                Back to login
              </Typography>
            </div>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
